export default __webpack_public_path__ + "static/media/cfo-portrait.b135583c.png";